import { createTheme } from '@mui/material/styles';

import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/700.css';

const theme = createTheme({
    typography: {
        fontFamily: [
            'Inter', // Primary font
            'Roboto', // Fallback for Material UI components
            'sans-serif',
        ].join(','),
    },
    palette:{
        primary:{
            main:"#176BE0",
            main_1:"#176BE0",
            main_2:"#9E17FF",
            light:"#e8d5f2ff",
        }
    }
})
export default theme;